import React from 'react';
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import LocalCafeIcon from '@mui/icons-material/LocalCafe';
import FavoriteIcon from '@mui/icons-material/Favorite';
import CodeIcon from '@mui/icons-material/Code';
import BuyMeACoffee from './buy_me_a_coffee';

export default function SupportUs() {
    return (
        <Container sx={{ py: 4 }}>
            {/* Header Section */}
            <Box sx={{ mb: 4 }}>
                <Typography variant="h4" component="h1" sx={{ fontWeight: 600, mb: 3 }}>
                    Support Development
                </Typography>

                {/* Information Section */}
                <Card variant="outlined" sx={{ mb: 4, backgroundColor: 'action.hover' }}>
                    <CardContent>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                            <LocalCafeIcon sx={{ color: '#FF813F', mt: 0.5, fontSize: 32 }} />
                            <Box sx={{ flex: 1 }}>
                                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                                    Help Keep PennyPusher Growing
                                </Typography>
                                <Typography variant="body2" color="text.secondary" paragraph>
                                    PennyPusher is built with passion and dedication. If you find the application useful 
                                    and would like to support continued development, new features, and improvements, 
                                    consider buying the developers a coffee. Your support helps us maintain and enhance 
                                    the software you rely on.
                                </Typography>
                                <Typography variant="body2" color="text.secondary" paragraph>
                                    Every contribution, no matter how small, makes a difference and is greatly appreciated. 
                                    Your support enables us to:
                                </Typography>
                                <Box component="ul" sx={{ pl: 3, mb: 2, color: 'text.secondary' }}>
                                    <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                                        Continue developing new features and improvements
                                    </Typography>
                                    <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                                        Maintain and update the application regularly
                                    </Typography>
                                    <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                                        Provide better support and documentation
                                    </Typography>
                                    <Typography component="li" variant="body2">
                                        Keep the software accessible and affordable
                                    </Typography>
                                </Box>
                                <Typography variant="body2" color="text.secondary">
                                    Thank you for being part of the PennyPusher community! <FavoriteIcon sx={{ fontSize: 16, color: 'error.main', verticalAlign: 'middle', mx: 0.5 }} />
                                </Typography>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Box>

            {/* Support Section */}
            <Box sx={{ textAlign: 'center' }}>
                <Card 
                    variant="outlined" 
                    sx={{ 
                        maxWidth: 500,
                        mx: 'auto',
                        p: 4,
                        backgroundColor: 'background.paper',
                        border: '2px solid',
                        borderColor: 'divider',
                        transition: 'all 0.2s ease-in-out',
                        '&:hover': {
                            boxShadow: 4,
                            transform: 'translateY(-2px)',
                        }
                    }}
                >
                    <CardContent>
                        <CodeIcon 
                            sx={{ 
                                fontSize: 64, 
                                color: 'primary.main', 
                                mb: 2,
                                filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
                            }} 
                        />
                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
                            Support the Developers
                        </Typography>
                        <Typography variant="body2" color="text.secondary" paragraph sx={{ mb: 3 }}>
                            Show your appreciation and help us continue building great software. 
                            Every contribution helps!
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                            <BuyMeACoffee 
                                variant="button"
                                size="large"
                            />
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </Container>
    );
}
